import React from 'react';
import { FloatingWrapper } from '@remirror/react';
import { Box, HStack, useColorModeValue } from '@cardboard-ui/react';
import { FormattingTools } from './FormattingTools';
import { HeadingTools } from './HeadingTools';
import { AlignTools } from './AlignTools';
import { ListTools } from './ListTools';
import { LinkTool } from './LinkTool';
import { HighlightTool } from './HighlightTool';

interface FloatingToolbarProps {
  editable: boolean;
  onOpenLinkTool: () => void;
}

export const FloatingToolbar = (props: FloatingToolbarProps) => {
  const bgColor = useColorModeValue('white', 'gray.700');

  return (
    <FloatingWrapper
      positioner="selection"
      placement="top-start"
      renderOutsideEditor
    >
      <Box
        bgColor={bgColor}
        boxShadow="base"
        borderRadius={3}
        display="flex"
        overflow="auto"
        marginInline={2}
      >
        <HStack h="32px" spacing={2} padding={2}>
          <FormattingTools />
          <ToolSeparator />
          <HighlightTool />
          <ToolSeparator />
          <AlignTools />
          <ToolSeparator />
          <ListTools />
          <ToolSeparator />
          <HeadingTools />
          <ToolSeparator />
          <LinkTool {...props} />
        </HStack>
      </Box>
    </FloatingWrapper>
  );
};

interface ToolSeparatorProps {
  height?: string | number;
}

export const ToolSeparator = ({ height }: ToolSeparatorProps) => {
  return (
    <div
      style={{
        borderLeft: '1px solid lightgray',
        width: '0',
        height: height || 'inherit',
      }}
    ></div>
  );
};
